<app-navbar-top></app-navbar-top>
<router-outlet></router-outlet>
<app-footer></app-footer>